import { useState } from "react";
import logoLight from "@/assets/dutch-dryice-horizontal-light.png";
import logoDark from "@/assets/dutch-dryice-horizontal-dark.png";
import iconSvg from "@/assets/dutch-dryice-icon.svg";

interface ThemeLogoProps {
  className?: string;
  variant?: "auto" | "light" | "dark";
}

const LogoImg = ({ src, className, ...props }: React.ImgHTMLAttributes<HTMLImageElement> & { src: string; className?: string }) => {
  const [error, setError] = useState(false);
  if (error) {
    return <img src={iconSvg} alt="Dutch DryIce" className={className} style={{ objectFit: 'contain', height: 'auto' }} />;
  }
  return <img src={src} className={className} onError={() => setError(true)} {...props} />;
};

/**
 * Auto: dark logo in light mode, light logo in dark mode.
 * light: always light logo (for forced-dark backgrounds like footer/sidebar).
 * dark: always dark logo (for forced-light backgrounds).
 */
const ThemeLogo = ({ className = "h-8", variant = "auto" }: ThemeLogoProps) => {
  if (variant === "light") {
    return <LogoImg src={logoLight} alt="Dutch DryIce" width={175} height={28} className={className} style={{ objectFit: 'contain', height: 'auto' }} />;
  }
  if (variant === "dark") {
    return <LogoImg src={logoDark} alt="Dutch DryIce" width={175} height={28} className={className} style={{ objectFit: 'contain', height: 'auto' }} />;
  }
  return (
    <>
      <LogoImg src={logoDark} alt="Dutch DryIce" width={175} height={28} className={`${className} dark:hidden`} />
      <LogoImg src={logoLight} alt="Dutch DryIce" width={175} height={28} className={`${className} hidden dark:block`} />
    </>
  );
};

export default ThemeLogo;
